import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import styled, { keyframes } from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';

ReactModal.defaultStyles = {
  overlay: {}
};
const backdropAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const StyledOverlay = styled.div.withConfig({
  componentId: "sg1510__sc-nrw51s-0"
})(["-webkit-overflow-scrolling:touch;animation:", " ", ";background-color:rgba(0,0,0,0.6);bottom:0;height:auto;left:0;overflow-x:auto;position:fixed;top:0;width:100vw;z-index:", ";"], backdropAnimation, tokens.transition.fast, tokens['z-index']['modal-backdrop']);
const ReactModalWrapper = _ref => {
  let {
    ariaLabelledby,
    children,
    contentElement,
    contentLabel,
    id,
    isOpen,
    onRequestClose,
    overlayClassName,
    shouldCloseOnOverlayClick,
    ...rest
  } = _ref;
  const [modalRef, setModalRef] = useState();
  useEffect(() => {
    if (!modalRef) {
      return;
    }
    const overlayElement = modalRef.firstElementChild;
    overlayElement && disableBodyScroll(overlayElement, {
      reserveScrollBarGap: true
    });
    const hiddenNodes = [];

    // Get all children elements of body (except the modal itself) and change
    // their aria-hidden attribute to true.
    const bodyChildren = Array.from(document.querySelectorAll('body > *'));
    for (const element of bodyChildren) {
      if (element !== modalRef) {
        hiddenNodes.push({
          element,
          originalValue: element.getAttribute('aria-hidden')
        });
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('aria-hidden');
      }
    }

    // Change aria-hidden attributes back to original values.
    return () => {
      overlayElement && enableBodyScroll(overlayElement);
      for (const node of hiddenNodes) {
        if (node.originalValue) {
          node.element.setAttribute('aria-hidden', node.originalValue);
        } else {
          node.element.removeAttribute('aria-hidden');
        }
      }
    };
  }, [modalRef]);
  return /*#__PURE__*/React__default.createElement(ReactModal, _extends({}, rest, {
    aria: {
      labelledby: ariaLabelledby
    },
    ariaHideApp: false,
    contentElement: contentElement,
    contentLabel: contentLabel,
    id: id,
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    overlayClassName: overlayClassName,
    overlayElement: (props, contentEl) => /*#__PURE__*/React__default.createElement(StyledOverlay, props, contentEl),
    overlayRef: node => setModalRef((node === null || node === void 0 ? void 0 : node.parentElement) || undefined),
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }), children);
};
ReactModalWrapper.displayName = 'ReactModalWrapper';

export { ReactModalWrapper };
